module.exports = __webpack_public_path__ + "ax.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ax.svg
// module id = 431
// module chunks = 0